// eslint-disable-next-line import/prefer-default-export
export { unstable_ClassNameGenerator } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/className/index.js
// module id = 1853
// module chunks = 25